import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { SHARED_LIB_CONFIG, SharedLibConfig } from "../config/lib-config";

@Injectable({
  providedIn: 'root',
})
export class EquipmentTemplateService {
  private pathApi: string;
  constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
    this.pathApi = this.config.pathApi + 'equipmentTemplate/';
  }

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  save(dataIn: any) {
    return this.http.post(`${this.pathApi}save`, dataIn, {
        observe : 'response',
    })
  }

  getByGuid(dataIn: any) {
    return this.http.post(`${this.pathApi}getByGuid`, dataIn, {
      observe: 'response',
    })
  }

  delete(dataIn: any) {
    return this.http.post(`${this.pathApi}delete`, dataIn, {
      observe: 'response',
    })
  }

}
